<template>
    <div 
      class="modal fade" 
      id="modalChangeMainPart" 
      role="dialog" 
      data-backdrop="static" 
      data-keyboard="false" 
      aria-labelledby="modalLabel" 
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
      >
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title black-text" style="font-weight: bold">
               Ganti Part Utama
              </h4> 
            </div>
            <button type="button" class="close" data-dismiss="modal" @click="resetState">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </button>
          </div>
          <div class="modal-body">
             <!-- Checkbox Items -->
            <div class="checkbox-group">
              <div v-for="item in partData" :key="item.tempId">
                <label class="checkbox-item">
                    <input 
                    type="checkbox" 
                    v-model="selectedParts"
                    :value="item"
                    class="checkbox-input"
                    />
                    <span class="checkbox-custom"></span>
                    <span class="checkbox-label">{{ item.itemName }}</span>
                </label>
              </div>
                
            </div>
          </div>
          <!-- Footer -->
            <div class="modal-footer">
                <button type="button" class="btn close-button" data-dismiss="modal" @click="resetState">
                Batal
                </button>
                <button class="btn confirm-button" @click="confirmAction" :disabled="selectedParts.length == 0">
                Konfirmasi
                </button>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'ModalChangeMainPart',
  props: ['partData','submitChanges', 'currentSelected'],
  data () {
    return {
      selectedParts : [],
    }
  },
  methods:{
    resetState() {
      this.selectedParts = [...this.currentSelected]
    },
    confirmAction() {
       this.submitChanges(this.selectedParts)
    },

    handleLogout() {
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
  },
  created(){
    this.admin = localStorage.getItem('admin_name')
    this.selectedParts = [...this.currentSelected]
  }
}
$(document).ready(function(){
  var self = this
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.checkbox-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 0.6rem;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid  #CFD3D9;
  background-color: #F8F9FA;
}

.checkbox-item {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  padding: 0.5rem 0;
}

.checkbox-input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkbox-custom {
  width: 1rem;
  height: 1rem;
  border: 2px solid #d1d5db;
  border-radius: 0.25rem;
  position: relative;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.checkbox-input:checked + .checkbox-custom {
  background-color: #247FEC;
  border-color: #3b82f6;
}

.checkbox-input:checked + .checkbox-custom::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 5px;
  width: 3px;
  height: 7px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.checkbox-label {
  font-size: 0.875rem;
  color: #374151;
  line-height: 1.25;
}

.close-button {
  background: none;
  border: 1px solid #2E3646;
  background-color: #F4F4F4;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  color: #6b7280;
  border-radius:  0.5rem;
  transition: all 0.2s ease;
}

.close-button:hover {
  color: #374151;
  background-color: #F4F4F4;
}

.confirm-button {
  background: none;
  border: 1px solid #247FEC;
  background-color: #3386eb;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  color: #FFFFFF;
  border-radius:  0.5rem;
  transition: all 0.2s ease;
}

</style>



// WEBPACK FOOTER //
// src/components/Assembly/CustomComponent/ModalChangeMainPart.vue